import { Intent, Button, Icon } from '@blueprintjs/core';
import { css } from '@stitches/react';
import { EndPointProps } from '@moleculeone/types';

interface PriceTreeButtonProps extends EndPointProps {
  smiles: string;
  hasPrice: boolean;
  onCartClick: (substrateId: string, smiles: string) => void;
}

const buttonStyle = css({
  borderRadius: '50px',
});

export function PriceTreeButton(props: PriceTreeButtonProps) {
  const { point, scale, padding, smiles, hasPrice, substrateId, onCartClick } = props;

  const endPointProps = {
    x: point[0],
    y: point[1],
    width: 45,
    height: 45,
  };

  return (
    <foreignObject
      x={endPointProps.x - endPointProps.width / 2 / scale - padding / scale}
      y={endPointProps.y - endPointProps.height / 2}
      width={endPointProps.width}
      height={endPointProps.height}
      style={{
        transform: `scale(${scale * 0.75}, ${scale * 0.75})`,
        transformOrigin: `${endPointProps.x - endPointProps.width / 2 / scale}px ${
          endPointProps.y - endPointProps.height / scale
        }px`,
        overflow: 'visible',
      }}
    >
      {hasPrice && (
        <Button
          className={buttonStyle()}
          intent={Intent.PRIMARY}
          onClick={() => {
            onCartClick(substrateId, smiles);
          }}
          data-test={`show-prices-button-${substrateId}`}
        >
          <Icon icon="shopping-cart" />
        </Button>
      )}
    </foreignObject>
  );
}
